import { ref } from "vue";

export type SheetPresentation = "sheet" | "modal";

const sheetPresentation = ref<SheetPresentation>("sheet");

export const setSheetPresentation = (value: SheetPresentation) => {
	sheetPresentation.value = value;
};

export const useSheetPresentation = () => sheetPresentation;
